import { render } from "./Frontpage.vue?vue&type=template&id=b442e8de&scoped=true"
import script from "./Frontpage.vue?vue&type=script&lang=ts"
export * from "./Frontpage.vue?vue&type=script&lang=ts"

import "./Frontpage.vue?vue&type=style&index=0&id=b442e8de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b442e8de"

export default script